export const messages = {
  labels: {
    diagnosisDate: {
      id: 'treatmentSummary.Groups.Diagnosis.DiagnosisDate',
      defaultMessage: 'Date: ',
    },
    laterality: {
      id: 'treatmentSummary.Groups.Diagnosis.Laterality',
      defaultMessage: 'Side: ',
    },
    histologyCode: {
      id: 'treatmentSummary.Groups.Diagnosis.HistologyCode',
      defaultMessage: 'Histology: ',
    },
    histologyDescription: {
      id: 'treatmentSummary.Groups.Diagnosis.HistologyDescription',
      defaultMessage: 'Histology Desc: ',
    },
    grade: {
      id: 'treatmentSummary.Groups.Diagnosis.Grade',
      defaultMessage: 'Grade: ',
    },
    stagingSystem: {
      id: 'treatmentSummary.Groups.Diagnosis.StagingSystem',
      defaultMessage: 'Stage System: ',
    },
    stage: {
      id: 'treatmentSummary.Groups.Diagnosis.Stage',
      defaultMessage: 'Stage: ',
    },
    tStage: {
      id: 'treatmentSummary.Groups.Diagnosis.TStage',
      defaultMessage: 'T: ',
    },
    nStage: {
      id: 'treatmentSummary.Groups.Diagnosis.NStage',
      defaultMessage: 'N: ',
    },
    mStage: {
      id: 'treatmentSummary.Groups.Diagnosis.MStage',
      defaultMessage: 'M: ',
    },
    provider: {
      id: 'treatmentSummary.Groups.Diagnosis.Provider',
      defaultMessage: 'Care Provider: ',
    },
    institution: {
      id: 'treatmentSummary.Groups.Diagnosis.Institution',
      defaultMessage: 'Facility: ',
    },
    providerPhone: {
      id: 'treatmentSummary.Groups.Diagnosis.ProviderPhone',
      defaultMessage: 'Phone: ',
    },
    providerEmail: {
      id: 'treatmentSummary.Groups.Diagnosis.ProviderEmail',
      defaultMessage: 'Email: ',
    },
    diagnosisType: {
      id: 'treatmentSummary.Groups.Diagnosis.DiagnosisType',
      defaultMessage: 'Type: ',
    },
    icdCode: {
      id: 'treatmentSummary.Groups.Diagnosis.IcdCode',
      defaultMessage: 'ICD Code: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.Diagnosis.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
